/**
 * @author Raghav Prabhu
 * @description Generic API client module
 */

import constants from '../../../settings/shared/constants'
import axios from 'axios'
import { loadProgressBar } from 'axios-progress-bar'

/**
 * Generic Axios client with default base URL
 */

const instance = axios.create({
  baseURL: constants.api.base.url
});

/**
 * https://www.npmjs.com/package/axios-progress-bar
 * https://www.npmjs.com/package/nprogress#configuration
 */
loadProgressBar({ 
  showSpinner: false,
  minimum: 0.1,
  trickleRate: 0.02,
  trickleSpeed: 800
}, instance)

// instance.defaults.headers.post['Content-Type'] = "application/json";
// instance.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem(ACCESS_TOKEN);
/**
 * API Wrapper with default success/error actions
 */
const service = function(options) {
  // console.log(JSON.stringify(options))
  const onErrorCallBack = options.onError
  if (onErrorCallBack) {
    delete options.onError
  }
  
  const onSuccess = function(response) {
    // console.debug('Request Successful!', response);
    return response.data;
  }
  
  const onError = function(error) {
    console.error('Request Failed:', error.config);
    if (error.response) {
      // Request was made but server responded with something
      // console.error('Status:',  error.response.status);
      if(error.response.status === 401) { //Token expires or unauthorized access
        localStorage.clear();
        sessionStorage.clear();
       // window.location.reload();
        window.location.href = '/auth/login-page'
      }
      if(error.response.status === 403) { //Unauthorized access
       // window.location.href = '/'
       // window.location.reload();
      }
      console.error('Data:',    error.response.data);
      console.error('Headers:', error.response.headers);

    } else {
      // Something else happened while setting up the request
      // triggered the error
      // console.error('Error Message:', error.message);
      if(!navigator.onLine){
        const channelOffline = new BroadcastChannel('message-offline');
        channelOffline.postMessage({data: "offline"});
      }
    }

    return Promise.reject(error.response || error.message);
  }
  //returns the default request
  return instance(options)
  .then(onSuccess)
  .catch(onErrorCallBack? onErrorCallBack : onError);
}

export default service;